// extracted by mini-css-extract-plugin
export default {"container":"Tabs_container__9MRJP","tab":"Tabs_tab__gR-Zl","isActive":"Tabs_isActive__4pZC3","counter":"Tabs_counter__HSlTJ","counterTextPadding":"Tabs_counterTextPadding__6UNiW"};